@if (current() >= max()) {
  <small class="character-count-error">
  ({{ current() }}/<span>{{ max() }}</span>)
</small>
}@else {
  <small class="character-count">
  ({{ current() }}/<span>{{ max() }}</span>)
</small>
}
